















import { Component, Prop, Vue } from 'vue-property-decorator';
import { BButton, BModal } from 'bootstrap-vue';

@Component({
    name: 'ModalRestart',
    components: {
        'b-modal': BModal,
        'b-button': BButton,
    },
})
export default class ModalRestart extends Vue {
    restart() {
        this.$store.commit('restart');
        location.reload();
    }
}
